import { createSlice } from '@reduxjs/toolkit'
import { FirestoreDatabase } from '../index'
import { Collection } from 'constants/index'
import { signOut } from 'store/auth'
import { first } from 'lodash'

export const initialState = {
  error: null,
  inProgress: false,
  config: null
}

const configSlice = createSlice({
  name: 'config',
  initialState: initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload
    },
    setProgress: (state, action) => {
      state.inProgress = action.payload
    },
    setConfig: (state, action) => {
      state.config = action.payload
    },
    updateConfig: (state, action) => {
      state.config = {
        ...state.config,
        ...action.payload
      }
    }
  },
  extraReducers: {
    [signOut.fulfilled]: (state) => {
      state.error = null
      state.inProgress = false
      state.config = []
    }
  }
})

export const fetchConfig = () => async (dispatch) => {
  try {
    dispatch(configSlice.actions.setProgress(true))
    FirestoreDatabase.collection(Collection.CONFIGURATIONS).onSnapshot((documents) => {
      const configurations = []
      documents.forEach((doc) => {
        configurations.push({
          id: doc.id,
          ...doc.data()
        })
      })
      dispatch(configSlice.actions.setConfig(first(configurations)))
      dispatch(configSlice.actions.setProgress(false))
    })
  } catch (err) {
    dispatch(configSlice.actions.setError(err))
    dispatch(configSlice.actions.setProgress(false))
  }
}

export const fetchSuperAdminConfiguration = async () => {
  try {
    const configSnap = await FirestoreDatabase.collection(Collection.CONFIGURATIONS).get()
    const configurations = configSnap?.docs?.map((doc) => {
      return { id: doc.id, ...doc.data() }
    })
    return first(configurations) ?? null
  } catch (err) {
    console.error(err)
  }
}

export const updateConfigById = (Id, payload, onSuccess, onError) => async (dispatch) => {
  try {
    await FirestoreDatabase.collection(Collection.CONFIGURATIONS).doc(Id).update(payload)
    dispatch(configSlice.actions.updateConfig(payload))
    onSuccess && onSuccess()
  } catch (err) {
    dispatch(configSlice.actions.setError(err))
    onError && onError(err)
  }
}

export default configSlice
